import { createFileRoute } from "@tanstack/react-router";
import { CloudflareConnection } from "@/components/cloudflare/connection";
import { StepPage } from "@/components/onboarding/step-page";

export const Route = createFileRoute("/onboarding/cloudflare")({
  component: CloudflareStep,
});

function CloudflareStep() {
  return (
    <StepPage
      path="/onboarding/cloudflare"
      intro="A DNS-edit token lets the platform create and repair records on your zones. Without one, every record is shown to copy into your DNS."
      asks={[
        {
          title: "An API token",
          text: "DNS edit on the zone is enough. It is stored encrypted and never shown again.",
        },
        {
          title: "The zones it reaches",
          text: "Listed once the token is saved, so the domain step can pick one.",
        },
      ]}
    >
      <CloudflareConnection />
    </StepPage>
  );
}
